
<main class="ddr-main">
	<div class="ddr-navbar">
		<div class="ddr-header">
				<div class="logo">
					<ul>
						<li class="logo-img">

						</li>
						<li>
							<h4 class="title" (click)="navigateTo('')">Deloitte Disaster Relief Fund</h4>
						</li>
					</ul>
				</div>

				<div class="header-links">
					<ul class="header-box">
						@for(tab of tabsList?.headerTabs; track tab) {                    
							<li class="header-list" [ngClass]="{ active: this.selectedHeader == tab.title }" (click)="navigateTo(tab.url)">
								{{ tab.title }}
							</li>                   
						}
					</ul>
				</div>

				<div class="ext-right">
					<ul class="external-link">
						@for(link of links; track link) {                  
							<li>
								<a href="{{link.url}}" target="_blank" class="blue-links cursor-pointer">
									<span [class]="link.class"></span>
									<span class="vertical-align-3">{{link.linkName}}</span>
								</a>
							</li>                    
						}
					</ul>
				</div>
		</div>

		<div class="user-dropdown">
			<kendo-dropdownbutton 
				class="username-container" 
				[data]="userDropdownData" 
				(itemClick)="onDropdownItemClick($event)"
			>
				<div>
					{{ displayName }}
				</div>

				<ng-template kendoDropDownButtonItemTemplate let-item>
					<div class="dropdown-item">
						<!-- Only show initials for the first item (name) -->
						@if(item.value === 'name') {
							<div class="initials-box">{{ displayName }}</div>
						}
						<span class="dropdown-text" [ngClass]="item.value === 'name' ? 'name-text' : 'mail-text'">{{ item.text }}</span>
					</div>
				</ng-template>
			</kendo-dropdownbutton>
		</div>
	</div>
</main>